(function ( $ ) {

	$.fn.ambassadorProfiles = function ( options ) {
		var elem = $( this ),
			classActive = 'js-selected',
			$ambassadorProfile = $('.profiles--inline-descriptions .profile');

		var init = function () {
			$ambassadorProfile.on( 'click', function ( e ) {
				e.preventDefault();

				$(this).toggleClass(classActive);
			} );
		};

		init();
		return this;
	};

}( jQuery ));
